import BadgeModel from 'garaje/models/badge';
import { belongsTo } from '@ember-data/model';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('badge')
class GlobalBadge extends BadgeModel {
  @belongsTo('global-flow') flow;
}

export default GlobalBadge;
